<g transform="translate(-11, 0)">
  <circle cx="11" cy="11" r="11" class="fill-red-500" />
  <g transform="translate(3, 3)">
    <path
      d="M24.045 43.071q-1.549 0-2.647-1.103-1.098-1.102-1.098-2.651 0-1.55 1.103-2.647 1.103-1.099 2.652-1.099 1.549 0 2.647 1.103 1.098 1.103 1.098 2.652 0 1.549-1.103 2.647-1.103 1.098-2.652 1.098zM20.3 30.214V4.5h7.5v25.714h-7.5z"
      class="fill-white scale-[0.3333333333333333]"
    />
  </g>
</g>
